import MainNav from "@worldwidegroup/support-ui/dist/Components/MainNav/MainNav";
import { ENVIRONMENT_CONFIG } from "shared/globals";
import "react-notifications-component/dist/theme.css";
import styles from "./App.module.css";

import React, { Suspense, useState, useEffect } from "react";
import { ReactNotifications } from "react-notifications-component";
import { Route, Switch, Redirect } from "react-router-dom";
import { useTitle } from "react-use";

import { NavState } from "@worldwidegroup/support-ui/dist/Components/Nav/useNavState";
import { Auth } from "shared/@auth/Auth";
import { setAuthTokenProvider } from "shared/api/client";
import { CurrentRouteContext } from "./shared/useCurrentRoute";
import SectionErrorBoundary from "shared/SectionErrorBoundary";
import LoadingPage from "./shared/LoadingPage";
import BSM from "./BSM";
import {
  setAnalyticsContext,
  identifyUser,
  trackEvent,
} from "./shared/analytics";

const { pageTitle, externalLinks, flags } = ENVIRONMENT_CONFIG;

function App() {
  useTitle(pageTitle);
  const { hasPermission, account, getToken } = Auth.useContainer();
  const { collapsed: navCollapsed } = NavState.useContainer();
  const [currentRoute, setCurrentRoute] = useState();

  // Identify the admin (support-staff) user to Segment once auth resolves. No-op
  // without a write key. IBO info is attached per event by feature code.
  useEffect(() => {
    if (!account) return;
    setAnalyticsContext({
      app: "wwg-store-admin",
      hostname: window.location.hostname,
      adminUser: account.username,
      adminName: account.name,
    });
    identifyUser(account.localAccountId || account.homeAccountId, {
      email: account.username,
      name: account.name,
    });
    // First event to light up the Segment source and confirm the pipe.
    trackEvent("Store Admin Session Started");
  }, [account]);

  // Register the MSAL token provider so the API client can attach a bearer
  // token when the real API is in use (the default). No-op in mock mode.
  useEffect(() => {
    if (!account) return;
    setAuthTokenProvider(() => getToken());
  }, [account, getToken]);

  return (
    <>
      <ReactNotifications />
      <CurrentRouteContext.Provider value={{ currentRoute, setCurrentRoute }}>
        <div className={styles.layout}>
          <MainNav
            fetchManagementTeamNotification={
              flags.fetchManagementTeamNotification &&
              hasPermission("management-team.*")
            }
            auth={Auth}
            navCollapsed={navCollapsed}
            externalLinks={externalLinks}
            currentRoute={currentRoute}
          />

          <main className={styles.main}>
            <SectionErrorBoundary>
              <Suspense fallback={<LoadingPage />}>
                <Switch>
                  {hasPermission("bsm.*") && (
                    <Route path="/store">
                      <BSM />
                    </Route>
                  )}

                  <Route path="*">
                    {hasPermission("bsm.*") ? (
                      <Redirect to="/store" />
                    ) : (
                      // NotFound is declared below; function declarations are hoisted, so this reference is valid.
                      <NotFound />
                    )}
                  </Route>
                </Switch>
              </Suspense>
            </SectionErrorBoundary>
          </main>
        </div>
      </CurrentRouteContext.Provider>
    </>
  );
}
export default App;

function NotFound() {
  return (
    <div className={styles.notFound}>
      <h1>Welcome to WWG Support</h1>
      <p>Choose a section on the left sidebar to get started.</p>
    </div>
  );
}
